"use client";

import {
  type AnalyticsAppSurface,
  type AnalyticsBaseProperties,
  compactAnalyticsProperties,
  createPublishSessionId,
  getAnalyticsEnvironment,
  type PostHogEventName,
} from "@studio/domain";
import type { PostHog } from "posthog-js";

function getDefaultContext(
  appSurface: AnalyticsAppSurface,
): Pick<AnalyticsBaseProperties, "app_surface" | "environment" | "platform"> {
  return {
    app_surface: appSurface,
    environment: getAnalyticsEnvironment(process.env.NODE_ENV),
    platform: "web",
  };
}

export function captureWebEvent(params: {
  posthog: PostHog | null | undefined;
  event: PostHogEventName | "$pageview";
  properties?: Record<string, unknown>;
  appSurface?: AnalyticsAppSurface;
}) {
  if (!params.posthog) {
    return;
  }

  params.posthog.capture(
    params.event,
    compactAnalyticsProperties({
      ...getDefaultContext(params.appSurface ?? "studio"),
      ...params.properties,
    }),
  );
}

export function identifyWebUser(params: {
  posthog: PostHog | null | undefined;
  user: { email?: string | null; id: string; name?: string | null };
}) {
  if (!params.posthog) {
    return;
  }

  params.posthog.identify(
    params.user.id,
    compactAnalyticsProperties({
      email: params.user.email ?? undefined,
      name: params.user.name ?? undefined,
    }),
  );
}

export function getOrCreatePublishSessionId(currentValue?: string | null) {
  return currentValue ?? createPublishSessionId();
}
